import { Directive, HostListener, OnInit, ElementRef, Renderer, Renderer2, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { MatDialogContainer, MatDialogRef } from '@angular/material';
import { Subscription, Observable, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[drag-drop-directive]'
})
export class DragDropDirective implements OnInit {

  @Output() actionLinkEmitter = new EventEmitter<{action:"link"|"unlink", sourceId: number, targetId: number}>()

  private _subscription: Subscription;

  mouseStart: Position;

  mouseDelta: Position;

  offset: Position;

  constructor(
    private elementRef: ElementRef<any>,
    private el: ElementRef, 
    private renderer: Renderer2, 
    private cdr: ChangeDetectorRef) {
      
    }

  ngOnInit() {
    this.offset = this._getOffset();
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(start: MouseEvent) {
    this.mouseStart = {x: start.pageX, y: start.pageY};

    const mouseup$ = fromEvent(document, 'mouseup');
    this._subscription = mouseup$.subscribe((end: MouseEvent) => this.onMouseup(start, end));

    const mousemove$ = fromEvent(document, 'mousemove')
      .pipe(takeUntil(mouseup$))
      .subscribe((e: MouseEvent) => this.onMouseMove(e));

    this._subscription.add(mousemove$);
  }

  onMouseMove(event: MouseEvent) {
      this.mouseDelta = {x: (event.pageX - this.mouseStart.x), y: (event.pageY - this.mouseStart.y)};

      this._updatePosition(this.offset.y + this.mouseDelta.y, this.offset.x + this.mouseDelta.x);
  }

  onMouseup(start:any, end:any) {

    //console.log('e', start.target.attributes.port_id, 'd', end.target.attributes.port_id)

    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = undefined;
    }

    if ( this.mouseDelta && (Math.abs(this.mouseDelta.x) > 50 || Math.abs(this.mouseDelta.y) > 50)) {
      this.offset.x += this.mouseDelta.x;
      this.offset.y += this.mouseDelta.y;

      console.log('mouse delta ', this.mouseDelta)

      if(end.target.attributes.port_id != undefined && start.target.attributes.port_id !=undefined){
        console.log("valid source and target")
        this.actionLinkEmitter.emit({action: 'link', sourceId:+start.target.attributes.port_id.value , targetId:+end.target.attributes.port_id.value})
      }
      else {
        console.log("invalid source or target") //emitt error message, and show snackbar on the other side
      }
    }
    
    this.mouseDelta = undefined
  }

  private _updatePosition(top: number, left: number) {

    this.renderer.setStyle(this.elementRef.nativeElement, 'top', top + "px")
    this.renderer.setStyle(this.elementRef.nativeElement, 'left', left + "px")

  }

  private _getOffset(): Position {
    const box = 0;
    return {
      x:  pageXOffset,
      y:  pageYOffset
    };
  }
}


export interface Position {
  x: number;
  y: number;
}